import { render, staticRenderFns } from "./ModalSendListMobile.vue?vue&type=template&id=2a11160f&scoped=true"
import script from "./ModalSendListMobile.vue?vue&type=script&lang=js"
export * from "./ModalSendListMobile.vue?vue&type=script&lang=js"
import style0 from "./ModalSendListMobile.vue?vue&type=style&index=0&id=2a11160f&prod&lang=scss"
import style1 from "./ModalSendListMobile.vue?vue&type=style&index=1&id=2a11160f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11160f",
  null
  
)

export default component.exports